import css from "standard/css";

const style = css`
  :root {
    --border-width-none: 0;
    --border-width-hairline: 1px;
    --border-width-thin: 2px;
    --border-width-thick: 4px;
    --border-width-heavy: 8px;
  }
`;

export default style;
